import React from 'react';

const CampaignProducts = ({ id = 'produtos', ariaLabel, kicker, title, cards }) => (
  <section id={id} className="hhc-produtos" aria-label={ariaLabel}>
    <div className="hhc-prod-header hhc-reveal">
      <div className="hhc-kicker">{kicker}</div>
      <h2 className="hhc-h-display hhc-prod-title">{title}</h2>
    </div>

    <div className="hhc-prod-grid">
      {cards.map((card, index) => (
        <div
          key={card.id ?? card.name}
          className="hhc-prod-card hhc-reveal"
          style={{ transitionDelay: `${0.05 + index * 0.05}s` }}
        >
          <img src={card.img} alt={card.alt} loading="lazy" decoding="async" />
          <div className="hhc-prod-ov" aria-hidden="true">
            <div className="hhc-prod-tag">{card.tag}</div>
            <div className="hhc-prod-name">{card.name}</div>
          </div>
          <div className="hhc-prod-bar" aria-hidden="true" />
        </div>
      ))}
    </div>
  </section>
);

export default CampaignProducts;
